import React from "react";
import CircularProgressbar from "react-circular-progressbar";
import Arrow from "./Arrow";
import "react-circular-progressbar/dist/styles.css";
import StatsUtils from "../../../../utils/stats";
import CountUp from "react-countup";

const Doughnuts = props => {
  const trend = Math.sign(props.newestPercentage - props.oldestPercentage);
  const color = trend === 1 ? "#54CD98" : trend === -1 ? "#DB1E08" : "#FEA701";
  const value = props.newestPercentage || 0;
  const kpi = props.kpi || {};
  const size = props.size || null;
  return (
    <div
      className="p-al-r-center p-w-h-100"
      style={{ maxWidth: "150px", minWidth: size == "small" ? "100px" : "150px" }}
    >
      <div style={{ position: "relative" }}>
        <CircularProgressbar
          percentage={props.full ? 100 : props.newestPercentage}
          initialAnimation
          styles={{
            path: {
              transition: "stroke-dashoffset 3s ease 0s",
              stroke: `${color}`
            }
          }}
        />
        <div
          className="p-al-c-full-center p-w-h-100"
          style={{ position: "absolute", top: 1, maxWidth: "150px", minWidth: size == "small" ? "100px" : "150px" }}
        >
          <div className="p-al-c-full-center">
            <div>
              <Arrow size={size} trend={trend} />
            </div>
            <div
              style={{
                fontSize: size == "small" ? "2.2vh" : "2.5vh",
                fontWeight: "bold",
                marginTop: "7%"
              }}
            >
              <CountUp
                start={0}
                end={StatsUtils.roundKpiValue(kpi, value)}
                duration={3}
                separator=" "
                style={{
                  fontSize: size == "small" ? "2.2vh" : "2.5vh"
                }}
                decimals={value % 1 === 0 ? 0 : 2}
                formattingFn={v => {
                  return StatsUtils.formatKpiValue(kpi, v);
                }}
              />
            </div>
            {props.circleTitle ? <div className="p-stats-home-item-title">{props.circleTitle}</div> : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doughnuts;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/Doughnut.js